import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, MapPin } from "lucide-react";
import MarketingLayout from "../components/marketing/MarketingLayout";
import { fadeUp } from "../components/marketing/Blocks";

export default function NotFound() {
  return (
    <MarketingLayout>
      <section className="relative flex min-h-[72vh] items-center overflow-hidden bg-shipany-navy" data-testid="not-found-page">
        <div className="pointer-events-none absolute inset-0 hero-grid opacity-40" />
        <div className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-shipany-cyan/10 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-[#FF9933]/10 blur-3xl" />
        <div className="relative mx-auto max-w-2xl px-5 py-20 text-center">
          <motion.div {...fadeUp}>
            <p className="mono text-xs font-bold uppercase tracking-[0.3em] text-shipany-cyan" data-testid="not-found-code">Error 404</p>
            <h1 className="font-display mt-4 text-5xl font-extrabold tracking-tight text-white sm:text-7xl" data-testid="not-found-title">
              Page <span className="text-saffron-green">Not Found</span>
            </h1>
            <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base" data-testid="not-found-desc">
              This route doesn't exist. The page you're looking for may have been moved, renamed or never shipped.
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link to="/" data-testid="not-found-home-btn"
                className="flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#FF9933] to-[#FF8000] px-8 py-3.5 font-display text-sm font-bold text-[#071B3A] transition-all hover:shadow-[0_8px_30px_rgba(255,153,51,0.45)]">
                <Home className="h-4 w-4" /> Go to Home
              </Link>
              <Link to="/track-shipment" data-testid="not-found-track-btn"
                className="flex items-center justify-center gap-2 rounded-xl border border-white/20 px-8 py-3.5 font-display text-sm font-bold text-white transition-colors hover:bg-white/5">
                <MapPin className="h-4 w-4" /> Track a Shipment
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </MarketingLayout>
  );
}
